// extracted by mini-css-extract-plugin
export var printerCard = "_al-1";
export var printerCardConfigured = "_al-2";
export var printerCardError = "_al-3";
export var printerCardsContainer = "_al-0";
export var printerIcon = "_al-8";
export var printerIconConfigured = "_al-5";
export var printerIconContainer = "_al-4";
export var printerIconError = "_al-6";
export var printerIconUnconfigured = "_al-7";
export var workstationsTableCard = "_al-9";